export default __webpack_public_path__ + "img/e4b56dec6a99a4039718a7a6905a9a31.png";